import 'css-chunk:../../src/components/ball/index.module.scss';export default {
  "ball": "_ball_1manw_1",
  "inflates": "_inflates_1manw_11",
  "inflated": "_inflated_1manw_18"
};